module.exports = __webpack_public_path__ + "media/images/covid/icons/hand-810c37dd6a294af94a00f0a01c4c2016.svg";